import { jsx as _jsx } from "react/jsx-runtime";
import { DatePicker } from '@emburse/embark-core';
import { useFormContext, Controller } from 'react-hook-form';
import { get } from 'lodash';
function FormDatePicker({ name, rules, ...datePickerProps }) {
    const { control, formState: { errors } } = useFormContext();
    const error = get(errors, name);
    const helperText = error ? error.message : datePickerProps.helperText;
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: ({ field }) => (_jsx(DatePicker, { ...field, ...datePickerProps, onChange: (date) => {
                field.onChange(date);
                if (datePickerProps.onChange) {
                    datePickerProps.onChange(date);
                }
            }, slotProps: {
                textField: {
                    id: datePickerProps.id,
                    fullWidth: datePickerProps.fullWidth,
                    error: !!error || Boolean(datePickerProps.error),
                    size: 'small',
                    helperText
                }
            } })) }));
}
FormDatePicker.defaultProps = {
    rules: {},
    helperText: '',
    fullWidth: false,
    onChange: undefined,
    error: false
};
export default FormDatePicker;
